<div class="time-filter">
  <div class="label-tiny">
    {{ warningType === WarningTypeEnum.VehicleDelay ? ('Delay' | translate) : ('Deviation' | translate) }}
  </div>

  <button mat-icon-button (click)="decreaseDeviationFilter()">-</button>

  @if (showHours) {
    <div class="input-wrapper">
      <input type="number" [(ngModel)]="deviationsFilter.hours" (ngModelChange)="selectedDeviationHoursChange($event)"
        min="0" />
        <span class="input-suffix">h</span>
      </div>
    }

    @if (showMinutes) {
      <div class="input-wrapper">
        <input type="number" [ngModel]="deviationsFilter.minutes"
          (ngModelChange)="selectedDeviationMinutesChange($event)" min="0" max="59" />
          <span class="input-suffix">m</span>
        </div>
      }

      @if (showSeconds) {
        <div class="input-wrapper">
          <input type="number" [ngModel]="deviationsFilter.seconds"
            (ngModelChange)="selectedDeviationSecondsChange($event)" min="0" max="59" />
            <span class="input-suffix">s</span>
          </div>
        }
        <button mat-icon-button (click)="increaseDeviationFilter()">+</button>
      </div>